<div class="dialog">
  <app-svg class="big-icon" src="/assets/icons/user-bell.svg" size="2"></app-svg>
  <h1>Subscribers</h1>

  @let galleryWatchers = galleryWatchers$ | async;
  @let assetWatchers = galleryAssetWatchers$ | async;

  @if (!galleryWatchers || !assetWatchers) {
    <app-loading-indicator></app-loading-indicator>
  } @else {
    <h3>
      <span>Gallery Subscribers</span>
      <app-svg
        src="/assets/icons/info-outline.svg"
        appTooltip="People who receive activity updates for every assets."
      ></app-svg>
    </h3>

    @if (!galleryWatchers.length) {
      <p class="no-subscribers">No subscribers</p>
    } @else {
      <div class="watcher-container">
        @for (watcher of galleryWatchers; track watcher.id) {
          <app-context-menu [options]="{ width: '240px', openOnHover: true, allowClicks: true, noSpacing: true }" #menu>
            <div class="watcher" contextButton>
              <app-avatar [user]="watcher"></app-avatar>
              <span>{{ watcher.first_name }} {{ watcher.last_name }}</span>
              <button
                appButton
                name="remove"
                location="gallery-subscribers-dialog"
                [iconButton]="true"
                height="-2"
                color="simple-gray-50"
                shape="round"
                (click)="removeWatcher(watcher.id)"
              >
                <app-svg src="/assets/icons/16/cross.svg"></app-svg>
              </button>
            </div>
            <div contextContent>
              @if (menu.isOpen) {
                <app-profile-preview
                  [user]="$any(watcher)"
                  [email]="watcher.email"
                  [isTeamMember]="true"
                ></app-profile-preview>
              }
            </div>
          </app-context-menu>
        }
      </div>
    }

    <h3>
      <span>Asset Subscribers</span>
      <app-svg
        src="/assets/icons/info-outline.svg"
        appTooltip="People who receive activity updates for individual assets."
      ></app-svg>
    </h3>

    @if (!assetWatchers.length) {
      <p class="no-subscribers">No subscribers</p>
    } @else {
      <div class="watcher-container">
        @for (watcher of assetWatchers; track watcher.id) {
          <app-context-menu [options]="{ width: '240px', openOnHover: true, allowClicks: true, noSpacing: true }" #menu>
            <div class="watcher" contextButton>
              <app-avatar [user]="watcher"></app-avatar>
              <span>{{ watcher.first_name }} {{ watcher.last_name }}</span>
              <button
                appButton
                name="remove"
                location="gallery-subscribers-dialog"
                [iconButton]="true"
                height="-2"
                color="simple-gray-50"
                shape="round"
                (click)="removeWatcher(watcher.id)"
              >
                <app-svg src="/assets/icons/16/cross.svg"></app-svg>
              </button>
            </div>
            <div contextContent>
              @if (menu.isOpen) {
                <app-profile-preview
                  [user]="watcher.type === 'user' ? $any(watcher) : undefined"
                  [guest]="watcher.type === 'guest' ? $any(watcher) : undefined"
                  [email]="watcher.email"
                  [isTeamMember]="true"
                ></app-profile-preview>
              }
            </div>
          </app-context-menu>
        }
      </div>
    }

    <label for="allow-new-subscribers" class="switch-container">
      <app-switch [small]="true">
        <input
          type="checkbox"
          id="allow-new-subscribers"
          [(ngModel)]="gallery.notifications_enabled"
          (ngModelChange)="toggleNotificationsEnabled()"
          appClickTrack
          name="lightbox"
          location="gallery-subscribers-dialog"
          [extra]="{ value: gallery.notifications_enabled }"
        />
        <label for="allow-new-subscribers"></label>
      </app-switch>
      <span>Allow new subscribers</span>
      <app-svg
        src="/assets/icons/info-outline.svg"
        appTooltip="Allow new people who interact with assets to receive activity updates."
      ></app-svg>
    </label>

    <button
      appButton
      name="ok"
      location="gallery-subscribers-dialog"
      color="primary"
      spacing="full"
      height="4"
      size="3"
      shape="round"
      (click)="close()"
    >
      Ok
    </button>
  }
</div>
